
export const listFonctionAdmin = [
    {
        libelle: 'Ecorec', submenus: [
            {
                id: 1, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/clientdoublon', code: 'clefDroitAdmin', droit: '0x00000001', libelleObjetEntite: 'Supprimer un Client en doublon'
            },
            {
                id: 2, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/chantierdoublon', code: 'clefDroitAdmin', droit: '0x00000002', libelleObjetEntite: 'Supprimer un Chantier en doublon'
            },
            {
                id: 3, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/personneldoublon', code: 'clefDroitAdmin', droit: '0x00000004', libelleObjetEntite: 'Supprimer un personnel en doublon'
            },
            {
                id: 4, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/bloquerclient', code: 'clefDroitAdmin', droit: '0x00000008', libelleObjetEntite: 'Bloquer un Client'
            },
            {
                id: 5, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/debloquerclient', code: 'clefDroitAdmin', droit: '0x00000010', libelleObjetEntite: 'Débloquer un Client'
            },
            {
                id: 6, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/codeclient', code: 'clefDroitAdmin', droit: '0x00000020', libelleObjetEntite: 'Modifier le code d\'un Client'
            },
            {
                id: 7, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerarticle', code: 'clefDroitAdmin', droit: '0x00000040', libelleObjetEntite: 'Masquer un Article'
            },
            {
                id: 8, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerarticle', code: 'clefDroitAdmin', droit: '0x00000080', libelleObjetEntite: 'Démasquer un Article'
            },
            {
                id: 9, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/visibiliteClient', code: 'clefDroitAdmin', droit: '0x00000100', libelleObjetEntite: 'Visibilité d\'un client'
            },
            {
                id: 10, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/fusionnerTransporteur', code: 'clefDroitAdmin', droit: '0x00000200', libelleObjetEntite: 'Supprimer un Transporteur en doublon'
            },
            {
                id: 11, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/siteChantier', code: 'clefDroitAdmin', droit: '0x00000400', libelleObjetEntite: 'Modification du site d\'un chantier'
            },
            {
                id: 12, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/dateCessionCamion', code: 'clefDroitAdmin', droit: '0x00000800', libelleObjetEntite: 'Modifier la date de cession d\'un camion'
            },
            {
                id: 13, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerUtilisateur', code: 'clefDroitAdmin', droit: '0x00001000', libelleObjetEntite: 'Masquer un utilisateur'
            },
            {
                id: 14, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerUtilisateur', code: 'clefDroitAdmin', droit: '0x00002000', libelleObjetEntite: 'Démasquer un utilisateur'
            },
            {
                id: 15, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerTypeBenne', code: 'clefDroitAdmin', droit: '0x00004000', libelleObjetEntite: 'Masquer une famille de contenant'
            },
            {
                id: 16, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerTypeBenne', code: 'clefDroitAdmin', droit: '0x00008000', libelleObjetEntite: 'Démasquer une famille de contenant'
            },
            {
                id: 17, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerCubageBenne', code: 'clefDroitAdmin', droit: '0x00010000', libelleObjetEntite: 'Masquer un cubage de benne'
            },
            {
                id: 18, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerCubageBenne', code: 'clefDroitAdmin', droit: '0x00020000', libelleObjetEntite: 'Démasquer un cubage de benne'
            },
            {
                id: 19, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerTypeContenant', code: 'clefDroitAdmin', droit: '0x00040000', libelleObjetEntite: 'Masquer un type de contenant'
            },
            {
                id: 20, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerTypeContenant', code: 'clefDroitAdmin', droit: '0x00080000', libelleObjetEntite: 'Démasquer un type de contenant'
            },
            {
                id: 21, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/chauffeurTransporteur', code: 'clefDroitAdmin', droit: '0x00100000', libelleObjetEntite: 'Masquer / Démasquer un chauffeur transporteur'
            },
            {
                id: 22, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/camionTransporteur', code: 'clefDroitAdmin', droit: '0x00200000', libelleObjetEntite: 'Masquer / Démasquer un camion transporteur'
            },
            {
                id: 23, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/chauffeurClient', code: 'clefDroitAdmin', droit: '0x00400000', libelleObjetEntite: 'Masquer / Démasquer un chauffeur d\'un client'
            },
            {
                id: 24, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/camionClient', code: 'clefDroitAdmin', droit: '0x00800000', libelleObjetEntite: 'Masquer / Démasquer un camion d\'un client'
            },
            {
                id: 25, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerClientSupp', code: 'clefDroitAdmin', droit: '0x01000000', libelleObjetEntite: 'Masquer / Démasquer un champs client supp'
            },
            {
                id: 26, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/modificationChantier', code: 'clefDroitAdmin', droit: '0x02000000', libelleObjetEntite: 'Modifier les informations d\'un chantier'
            },
            {
                id: 27, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerFormatPerso', code: 'clefDroitAdmin', droit: '0x04000000', libelleObjetEntite: 'Masquer un format perso'
            },
            {
                id: 28, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerFormatPerso', code: 'clefDroitAdmin', droit: '0x08000000', libelleObjetEntite: 'Démasquer un format perso'
            },
            {
                id: 29, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/fusionnerLieuChantier', code: 'clefDroitAdmin', droit: '0x10000000', libelleObjetEntite: 'Fusionner deux lieux chantier'
            },
            {
                id: 30, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerExutoire', code: 'clefDroitAdmin', droit: '0x20000000', libelleObjetEntite: 'Masquer un exutoire'
            },
            {
                id: 31, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerExutoire', code: 'clefDroitAdmin', droit: '0x40000000', libelleObjetEntite: 'Démasquer un exutoire'
            },
            {
                id: 32, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/multipesees', code: 'clefDroitAdmin', droit: '0x80000000', libelleObjetEntite: 'Modifier les multipesées'
            },
            {
                id: 33, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerTypePaie', code: 'clefDroitAdmin2', droit: '0x00000001', libelleObjetEntite: 'Masquer/Démasquer un type de paiement'
            },
            {
                id: 34, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerCompte', code: 'clefDroitAdmin2', droit: '0x00000002', libelleObjetEntite: 'Masquer/Démasquer un compte'
            },
            {
                id: 35, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/modifierCoordGPSChantier', code: 'clefDroitAdmin2', droit: '0x00000004', libelleObjetEntite: 'Modification des coordonnées GPS des chantiers'
            },
            {
                id: 36, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/modifierSitesBon', code: 'clefDroitAdmin2', droit: '0x00000008', libelleObjetEntite: 'Modifier les sites d\'un bon'
            },
            {
                id: 37, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerTransporteur', code: 'clefDroitAdmin2', droit: '0x00000010', libelleObjetEntite: 'Masquer/Démasquer un transporteur'
            },
            {
                id: 38, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/modifierImatCamionclient', code: 'clefDroitAdmin2', droit: '0x00000020', libelleObjetEntite: 'Modifier les camions d\'un client'
            },
            {
                id: 39, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/masquerTVA', code: 'clefDroitAdmin2', droit: '0x00000040', libelleObjetEntite: 'Masquer/Demasquer un taux de tva'
            },
            {
                id: 40, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/modifierAdressChantier', code: 'clefDroitAdmin2', droit: '0x00000080', libelleObjetEntite: 'Modifier l\'adresse d\'un chantier'
            },
            {
                id: 41, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/demasquerAgenceInterim', code: 'clefDroitAdmin2', droit: '0x00000100', libelleObjetEntite: 'Masquer/Démasquer une agence d\'interim'
            },
            {
                id: 43, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/fusionAdresseBAK', code: 'clefDroitAdmin2', droit: '0x00000400', libelleObjetEntite: 'Fusion adresse BAK'
            },
            {
                id: 150, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/fusionExutoire', code: 'clefDroitAdmin5', droit: '0x00200000', libelleObjetEntite: 'Fusionner 2 exutoires'
            },
            {
                id: 153, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/bloqueClientCentre', code: 'clefDroitAdmin5', droit: '0x01000000', condition: 'blocageClientParCentre', libelleObjetEntite: 'Blocage d\'un client'
            },
            {
                id: 154, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/debloqueClientCentre', code: 'clefDroitAdmin5', droit: '0x02000000', condition: 'blocageClientParCentre', libelleObjetEntite: 'Déblocage d\'un client'
            },
            {
                id: 173, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/impTarifArticle', code: 'clefDroitAdmin6', droit: '0x00020000', libelleObjetEntite: 'Importation des tarifs des articles'
            },
            {
                id: 174, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/impIndiceIndex', code: 'clefDroitAdmin6', droit: '0x00040000', libelleObjetEntite: 'Importation des valeurs des indices'
            }
        ]
    },
    {
        libelle: 'Ecoachat', submenus: [
            {
                id: 44, libelle: 'Ecoachat', route: '/recylog/fonctionAdmin/Ecoachat/fusionnerFourniture', code: 'clefDroitAdmin2', droit: '0x00000800', libelleObjetEntite: 'Fusionner 2 fournitures'
            }
        ]
    },
    {
        libelle: 'Ecobac', submenus: [
            {
                id: 45, libelle: 'Ecobac', route: '/recylog/fonctionAdmin/Ecobac/modifierOperationBacBon', code: 'clefDroitAdmin2', droit: '0x00001000', libelleObjetEntite: 'Modification de l\'opération bac du bon sur : TEST SUPPORT'
            },
            {
                id: 160, libelle: 'Ecobac', route: '/recylog/fonctionAdmin/Ecobac/importBacs', code: 'clefDroitAdmin5', droit: '0x80000000', libelleObjetEntite: 'Importation des bacs'
            }
        ]
    },
    {
        libelle: 'Ecobennes', submenus: [
            {
                id: 46, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBDebloquePlanning', code: 'clefDroitAdmin2', droit: '0x00002000', libelleObjetEntite: 'Debloquer le planning'
            },
            {
                id: 47, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBMasquerChauffeur', code: 'clefDroitAdmin2', droit: '0x00004000', libelleObjetEntite: 'Masquer / Démasquer un personnel'
            },
            {
                id: 48, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBMasquerOperationBenne', code: 'clefDroitAdmin2', droit: '0x00008000', libelleObjetEntite: 'Masquer / Démasquer une opération benne'
            },
            {
                id: 49, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBModifQteContenant', code: 'clefDroitAdmin2', droit: '0x00010000', libelleObjetEntite: 'Modifier la quantité de contenant'
            },
            {
                id: 50, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBModifNumBenne', code: 'clefDroitAdmin2', droit: '0x00020000', libelleObjetEntite: 'Modifier le numéro d\'une benne'
            },
            {
                id: 51, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBModifParkingMouvement', code: 'clefDroitAdmin2', droit: '0x00040000', libelleObjetEntite: 'Modifier le parking d\'un bon'
            },
            {
                id: 52, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBModifCouleurOperation', code: 'clefDroitAdmin2', droit: '0x00080000', libelleObjetEntite: 'Modifier la couleur d\'une opération'
            },
            {
                id: 53, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBAnnulerRealisationMouvement', code: 'clefDroitAdmin2', droit: '0x00100000', libelleObjetEntite: 'Annuler la réalisation d\'un mouvement'
            },
            {
                id: 54, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBModifierKilometrageCamion', code: 'clefDroitAdmin2', droit: '0x00200000', libelleObjetEntite: 'Modifier le kilométrage d\'un camion'
            },
            {
                id: 55, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBModifNumBenneHistorique', code: 'clefDroitAdmin2', droit: '0x00400000', libelleObjetEntite: 'Modifier les numéros de benne d\'un bon en historique'
            },
            {
                id: 56, libelle: 'Ecobennes', route: '/recylog/fonctionAdmin/Ecobennes/DBDupliquerChantierContenant', code: 'clefDroitAdmin2', droit: '0x00800000', libelleObjetEntite: 'Transfert des contenants d\'un client vers un autre client'
            },
            {
                id: 152, libelle: 'Fonctions', route: '/recylog/fonctionAdmin/Ecobennes/debloquersynchrosygtrack', code: 'clefDroitAdmin5', droit: '0x00800000', libelleObjetEntite: 'Débloquer synchronisation Sygetrack'
            },
            {
                id: 169, libelle: 'Fonctions', route: '/recylog/fonctionAdmin/Ecobennes/DBModifInfoChauffeurJour', code: 'clefDroitAdmin6', droit: '0x00002000', libelleObjetEntite: 'Modifier le litrage'
            }
        ]
    },

    {
        libelle: 'Ecocontrat', submenus: [
            {
                id: 57, libelle: 'Ecocontrat', route: '/recylog/fonctionAdmin/Ecocontrat/annulationValidationLigneContrat', code: 'clefDroitAdmin2', droit: '0x01000000', libelleObjetEntite: 'Annuler la validation d\'une ligne'
            },
            {
                id: 58, libelle: 'Ecocontrat', route: '/recylog/fonctionAdmin/Ecocontrat/MAJDataTechEcoBenne', code: 'clefDroitAdmin2', droit: '0x02000000', libelleObjetEntite: 'Modification du contrat des données techniques Ecobennes'
            },
            {
                id: 59, libelle: 'Ecocontrat', route: '/recylog/fonctionAdmin/Ecocontrat/MAJDataTechEcoloc', code: 'clefDroitAdmin2', droit: '0x04000000', libelleObjetEntite: 'Modification du contrat des données techniques Ecoloc'
            },
            {
                id: 125, libelle: 'Ecogrc', route: '/recylog/fonctionAdmin/Ecogrc/desolderContrat', code: 'clefDroitAdmin4', droit: '0x10000000', libelleObjetEntite: 'Désolder un contrat'
            }
        ]
    },
    {
        libelle: 'Ecodec', submenus: [
            {
                id: 60, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/annulerExpVHU', code: 'clefDroitAdmin2', droit: '0x08000000', libelleObjetEntite: 'Annulation de la validation d\'une expédition VHU'
            },
            {
                id: 61, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifDatePriseChargeVHU', code: 'clefDroitAdmin2', droit: '0x10000000', libelleObjetEntite: 'Modification de la date de prise en charge d\'un VHU'
            },
            {
                id: 62, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/desimpressionLivrePolice', code: 'clefDroitAdmin2', droit: '0x20000000', libelleObjetEntite: 'Désimprimer le livre de police des VHU'
            },
            {
                id: 63, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifDecVHU', code: 'clefDroitAdmin2', droit: '0x40000000', libelleObjetEntite: 'Modification d\'un VHU suite au retour de la déclaration'
            },
            {
                id: 64, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/historiserVHU', code: 'clefDroitAdmin2', droit: '0x80000000', libelleObjetEntite: 'SIV : Historiser un VHU'
            },
            {
                id: 65, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifVHUMarque', code: 'clefDroitAdmin3', droit: '0x00000001', libelleObjetEntite: 'Modifier une marque'
            },
            {
                id: 66, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifVHUDenomCle', code: 'clefDroitAdmin3', droit: '0x00000002', libelleObjetEntite: 'Modifier une dénomination commerciale'
            },
            {
                id: 67, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifVHUGenre', code: 'clefDroitAdmin3', droit: '0x00000004', libelleObjetEntite: 'Modifier un genre national'
            },
            {
                id: 68, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifVHUCarroserieNat', code: 'clefDroitAdmin3', droit: '0x00000008', libelleObjetEntite: 'Modifier une carroserie nationale'
            },
            {
                id: 69, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifVHUCat', code: 'clefDroitAdmin3', droit: '0x00000010', libelleObjetEntite: 'Modifier une catégorie (CE)'
            },
            {
                id: 70, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/modifClientVHU', code: 'clefDroitAdmin3', droit: '0x00000020', libelleObjetEntite: 'Modifier le client d\'un VHU'
            },
            {
                id: 167, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/masquerBroyeur', code: 'clefDroitAdmin6', droit: '0x00000800', libelleObjetEntite: 'Masquer un broyeur'
            },
            {
                id: 168, libelle: 'Ecodec', route: '/recylog/fonctionAdmin/Ecodec/demasquerBroyeur', code: 'clefDroitAdmin6', droit: '0x00001000', libelleObjetEntite: 'Démasquer un broyeur'
            }
        ]
    },
    {
        libelle: 'Ecodechet', submenus: [
            {
                id: 71, libelle: 'Ecodechet', route: '/recylog/fonctionAdmin/Ecodechet/DBModifTranspBon', code: 'clefDroitAdmin3', droit: '0x00000040', libelleObjetEntite: 'Modification du transporteur d\'un bon'
            },
            {
                id: 72, libelle: 'Ecodechet', route: '/recylog/fonctionAdmin/Ecodechet/DBModifPrestContratBon', code: 'clefDroitAdmin3', droit: '0x00000080', libelleObjetEntite: 'Modifier la prestation contrat d\'un bon'
            },
            {
                id: 73, libelle: 'Ecodechet', route: '/recylog/fonctionAdmin/Ecodechet/DBModifArticleBonPesees', code: 'clefDroitAdmin3', droit: '0x00000100', libelleObjetEntite: 'Modifier l\'article d\'origine d\'un bon avec nomenclature'
            }
        ]
    },
    {
        libelle: 'Ecodd', submenus: [
            {
                id: 74, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/debloqueBonEcoDD', code: 'clefDroitAdmin3', droit: '0x00000200', libelleObjetEntite: 'Debloquer un Bon ECODD'
            },
            {
                id: 75, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/remonteBonEcodd', code: 'clefDroitAdmin3', droit: '0x00000400', libelleObjetEntite: 'Remonter un Bon dans ECODD'
            },
            {
                id: 76, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/modifDateCAP', code: 'clefDroitAdmin3', droit: '0x00000800', libelleObjetEntite: 'Modifier la date d\'émission d\'un CAP'
            },
            {
                id: 77, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/contenantPlein', code: 'clefDroitAdmin3', droit: '0x00001000', libelleObjetEntite: 'Marquer un contenant DD comme plein'
            },
            {
                id: 78, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/annulerValidationExpeDD', code: 'clefDroitAdmin3', droit: '0x00002000', libelleObjetEntite: 'Annuler la validation d\'une expédition DD'
            },
            {
                id: 79, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/modifierNumContenantManuel', code: 'clefDroitAdmin3', droit: '0x00004000', libelleObjetEntite: 'Modifier numéro contenant manuel'
            },
            {
                id: 80, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/masquerEmplacementStock', code: 'clefDroitAdmin3', droit: '0x00008000', libelleObjetEntite: 'Masquer un emplacement stock'
            },
            {
                id: 81, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/masquerRayonStock', code: 'clefDroitAdmin3', droit: '0x00010000', libelleObjetEntite: 'Masquer un rayon stock'
            },
            {
                id: 82, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/demasquerEmplacementStock', code: 'clefDroitAdmin3', droit: '0x00020000', libelleObjetEntite: 'Démasquer un emplacement stock'
            },
            {
                id: 83, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/demasquerRayonStock', code: 'clefDroitAdmin3', droit: '0x00040000', libelleObjetEntite: 'Démasquer un rayon stock'
            },
            {
                id: 84, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/annulerMarquageContenuPlein', code: 'clefDroitAdmin3', droit: '0x00080000', libelleObjetEntite: 'Annuler le marquage d\'un contenant plein'
            },
            {
                id: 85, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/modifierCodeTraitementBSD', code: 'clefDroitAdmin3', droit: '0x00100000', libelleObjetEntite: 'Modifier le code traitement d\'un BSD'
            },
            {
                id: 86, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/modifierExpedition', code: 'clefDroitAdmin3', droit: '0x00200000', libelleObjetEntite: 'Modifier les informations de l\'expédition'
            },
            {
                id: 87, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/annulerRetourBSDD', code: 'clefDroitAdmin3', droit: '0x00400000', libelleObjetEntite: 'Annuler la validation du retour d\'un BSD'
            },
            {
                id: 88, libelle: 'Ecodd', route: '/recylog/fonctionAdmin/Ecodd/supprimerLienTrackdechetBSDD', code: 'clefDroitAdmin3', droit: '0x00800000', libelleObjetEntite: 'Supprimer le lien TrackDechet d\'un BSDD'
            }
        ]
    },
    {
        libelle: 'Ecofact', submenus: [
            {
                id: 89, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDefactBon', code: 'clefDroitAdmin3', droit: '0x01000000', libelleObjetEntite: 'Défacturer un Bon'
            },
            {
                id: 90, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDefactFact', code: 'clefDroitAdmin3', droit: '0x02000000', libelleObjetEntite: 'Défacturer une Facture'
            },
            {
                id: 91, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDefactFAE', code: 'clefDroitAdmin3', droit: '0x04000000', libelleObjetEntite: 'Défacturer une FAE'
            },
            {
                id: 92, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDefactBonAchat', code: 'clefDroitAdmin3', droit: '0x08000000', libelleObjetEntite: 'Défacturer un Bon d\'achat'
            },
            {
                id: 93, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDesimprimePiece', code: 'clefDroitAdmin3', droit: '0x10000000', libelleObjetEntite: 'Désimprimer une Pièce'
            },
            {
                id: 94, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDecomptaBonAchat', code: 'clefDroitAdmin3', droit: '0x20000000', libelleObjetEntite: 'Décomptabiliser une Pièce'
            },
            {
                id: 95, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDecomptaPeriode', code: 'clefDroitAdmin3', droit: '0x40000000', libelleObjetEntite: 'Décomptabiliser une période'
            },
            {
                id: 96, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBDecomptaRemiseBanque', code: 'clefDroitAdmin3', droit: '0x80000000', libelleObjetEntite: 'Décomptabiliser une remise de banque'
            },
            {
                id: 97, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBHistoBon', code: 'clefDroitAdmin4', droit: '0x00000001', libelleObjetEntite: 'Historiser un Bon'
            },
            {
                id: 98, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifTypeBon', code: 'clefDroitAdmin4', droit: '0x00000002', libelleObjetEntite: 'Modification du type d\'un bon'
            },
            {
                id: 99, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBAnnulationPaiement', code: 'clefDroitAdmin4', droit: '0x00000004', libelleObjetEntite: 'Annulation des paiements d\'une piece commerciale'
            },
            {
                id: 100, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBAnnulerFPBonAchat', code: 'clefDroitAdmin4', droit: '0x00000008', libelleObjetEntite: 'Annulation de FP sur un bon d\'achat'
            },
            {
                id: 101, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifExutoireBon', code: 'clefDroitAdmin4', droit: '0x000000010', libelleObjetEntite: 'Modification de l\'exutoire d\'un bon'
            },
            {
                id: 102, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifExutoireLigneBon', code: 'clefDroitAdmin4', droit: '0x00000020', libelleObjetEntite: 'Modification de l\'exutoire des lignes d\'un bon'
            },
            {
                id: 103, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifClientBon', code: 'clefDroitAdmin4', droit: '0x00000040', libelleObjetEntite: 'Modification du client d\'un bon'
            },
            {
                id: 104, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifChantierBon', code: 'clefDroitAdmin4', droit: '0x00000080', libelleObjetEntite: 'Modification du chantier d\'un bon'
            },
            {
                id: 105, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModificationIndiceRev', code: 'clefDroitAdmin4', droit: '0x000000100', libelleObjetEntite: 'Modification des indices de révision d\'une facture'
            },
            {
                id: 106, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModificationIndiceFAE', code: 'clefDroitAdmin4', droit: '0x00000200', libelleObjetEntite: 'Modification des indices de révision d\'un FAE'
            },
            {
                id: 107, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModificationIndiceRevAvoir', code: 'clefDroitAdmin4', droit: '0x00000400', libelleObjetEntite: 'Modification des indices de révision d\'un avoir'
            },
            {
                id: 108, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModificationIndiceRevAAE', code: 'clefDroitAdmin4', droit: '0x00000800', libelleObjetEntite: 'Modification des indices de révision AAE'
            },
            {
                id: 109, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBRepositionnerFactureImpayee', code: 'clefDroitAdmin4', droit: '0x00001000', libelleObjetEntite: 'Repositionnement d\'une facture impayée'
            },
            {
                id: 110, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifQteExpBon', code: 'clefDroitAdmin4', droit: '0x00002000', libelleObjetEntite: 'Modification des quantités expediées de lignes de bon'
            },
            {
                id: 111, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifContratBon', code: 'clefDroitAdmin4', droit: '0x00004000', libelleObjetEntite: 'Modification du contrat du bon'
            },
            {
                id: 112, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBAnnulerSaisieAxeAnalytique', code: 'clefDroitAdmin4', droit: '0x00008000', libelleObjetEntite: 'Annulation saisie axes analytiques pièce commerciale'
            },
            {
                id: 113, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifNonConformiteBon', code: 'clefDroitAdmin4', droit: '0x00010000', libelleObjetEntite: 'Modifier la non conformité d\'un bon'
            },
            {
                id: 114, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBAnnulerTropPercu', code: 'clefDroitAdmin4', droit: '0x00020000', libelleObjetEntite: 'Annuler l\'utilisation d\'un trop perçu'
            },
            {
                id: 115, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifCamionBon', code: 'clefDroitAdmin4', droit: '0x00040000', libelleObjetEntite: 'Modifier le camion sur un bon'
            },
            {
                id: 116, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifChauffeurBon', code: 'clefDroitAdmin4', droit: '0x00080000', libelleObjetEntite: 'Modifier le chauffeur sur un bon'
            },
            {
                id: 117, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBGenXMLChorus', code: 'clefDroitAdmin4', droit: '0x00100000', libelleObjetEntite: 'Générer un XML chorus à partir d\'une facture'
            },
            {
                id: 118, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifPeseeBon', code: 'clefDroitAdmin4', droit: '0x00200000', libelleObjetEntite: 'Modifier les pesées d\'un bon'
            },
            {
                id: 119, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBAnnulerBlocagePeriode', code: 'clefDroitAdmin4', droit: '0x00400000', libelleObjetEntite: 'Annuler le blocage d\'une période'
            },
            {
                id: 120, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBModifFactureChorus', code: 'clefDroitAdmin4', droit: '0x00800000', libelleObjetEntite: 'Modification d\'une facture et envoie à Chorus'
            },
            {
                id: 121, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBAnnulerValidationTeom', code: 'clefDroitAdmin4', droit: '0x01000000', libelleObjetEntite: 'Annuler la validation d\'une TEOM'
            },
            {
                id: 151, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/DBAdminCalculLoc', code: 'clefDroitAdmin5', droit: '0x00400000', libelleObjetEntite: 'Calcul des locations'
            },
            {
                id: 162, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/AchatAutoDatePart', code: 'clefDroitAdmin6', droit: '0x00000001', libelleObjetEntite: 'Achat auto à date particulière'
            },
            {
                id: 163, libelle: 'Ecofact', route: '/recylog/fonctionAdmin/Ecofact/FactAutoDatePart', code: 'clefDroitAdmin6', droit: '0x00000002', libelleObjetEntite: 'Fact auto à date particulière'
            }
        ]
    },
    {
        libelle: 'Ecogar', submenus: [
            {
                id: 122, libelle: 'Ecogar', route: '/recylog/fonctionAdmin/Ecogar/modifIndispoPrestCamion', code: 'clefDroitAdmin4', droit: '0x02000000', libelleObjetEntite: 'Modifier les dates d\'indispo d\'une prestation'
            },
            {
                id: 123, libelle: 'Ecogar', route: '/recylog/fonctionAdmin/Ecogar/modifierDateDernierePrestation', code: 'clefDroitAdmin4', droit: '0x04000000', libelleObjetEntite: 'Modifier la date de la dernière prestation'
            },
            {
                id: 124, libelle: 'Ecogar', route: '/recylog/fonctionAdmin/Ecogar/modifierDateProchainePrestation', code: 'clefDroitAdmin4', droit: '0x08000000', libelleObjetEntite: 'Modifier la date de la prochaine prestation'
            }
        ]
    },
    {
        libelle: 'Ecogrc', submenus: [

        ]
    },
    {
        libelle: 'Ecoloc', submenus: [
            {
                id: 126, libelle: 'Ecoloc', route: '/recylog/fonctionAdmin/Ecoloc/modifierDateProgLoc', code: 'clefDroitAdmin4', droit: '0x20000000', libelleObjetEntite: 'Modification de la date de programmation d\'une prestation'
            },
            {
                id: 127, libelle: 'Ecoloc', route: '/recylog/fonctionAdmin/Ecoloc/modifierKilometrageCamion', code: 'clefDroitAdmin4', droit: '0x40000000', libelleObjetEntite: 'Modifier le kilométrage d\'un camion'
            },
            {
                id: 128, libelle: 'Ecoloc', route: '/recylog/fonctionAdmin/Ecoloc/modifKmLocation', code: 'clefDroitAdmin4', droit: '0x80000000', libelleObjetEntite: 'Modifier les Km et litrage'
            }
        ]
    },
    {
        libelle: 'Ecopol', submenus: [
            {
                id: 129, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/annulationFermetureCaisse', code: 'clefDroitAdmin5', droit: '0x00000001', libelleObjetEntite: 'Annulation de la dernière fermeture de la caisse'
            },
            {
                id: 130, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/annulationBAPE', code: 'clefDroitAdmin5', droit: '0x00000002', libelleObjetEntite: 'Annulation d\'une déclaration fiscale BAP par année'
            },
            {
                id: 131, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/modifClientBAPE', code: 'clefDroitAdmin5', droit: '0x00000004', libelleObjetEntite: 'Modifier une déclaration fiscale BAP par année et par client'
            },
            {
                id: 132, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/desimprimerBAPE', code: 'clefDroitAdmin5', droit: '0x00000008', libelleObjetEntite: 'Désimprimer un BAP'
            },
            {
                id: 133, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/decomptaCaissePeriode', code: 'clefDroitAdmin5', droit: '0x00000010', libelleObjetEntite: 'Décomptabiliser la caisse sur une période'
            },
            {
                id: 134, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/annulerFichierVirement', code: 'clefDroitAdmin5', droit: '0x00000020', libelleObjetEntite: 'Annuler un fichier de virement'
            },
            {
                id: 135, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/autoriteIdentiteClient', code: 'clefDroitAdmin5', droit: '0x00000040', libelleObjetEntite: 'Modification de l\'autorité'
            },
            {
                id: 166, libelle: 'Ecopol', route: '/recylog/fonctionAdmin/Ecopol/AnnulerPaiementBAP', code: 'clefDroitAdmin6', droit: '0x00000400', libelleObjetEntite: 'Annuler le(s) paiement(s) d\'un bon d\'achats aux particuliers'
            }
        ]
    },
    {
        libelle: 'Ecoportail', submenus: [
            {
                id: 136, libelle: 'Ecoportail', route: '/recylog/fonctionAdmin/Ecoportail/DBSupprimerDoc', code: 'clefDroitAdmin5', droit: '0x00000080', libelleObjetEntite: 'Supprimer un document'
            },
            {
                id: 137, libelle: 'Ecoportail', route: '/recylog/fonctionAdmin/Ecoportail/DBAdminAssoArticleChauffeur', code: 'clefDroitAdmin5', droit: '0x00000100', libelleObjetEntite: 'Associations articles-chauffeurs'
            },
            {
                id: 170, libelle: 'Ecoportail', route: '/recylog/fonctionAdmin/Ecoportail/serviceUser', code: 'clefDroitAdmin6', droit: '0x00004000', libelleObjetEntite: 'Masquer / Démasquer services user'
            },
            {
                id: 171, libelle: 'Ecoportail', route: '/recylog/fonctionAdmin/Ecoportail/masquerTypeDemandeEcoGED', code: 'clefDroitAdmin6', droit: '0x00008000', libelleObjetEntite: 'Masquer / Démasquer typeDemandeEcoGED'
            }
        ]
    },
    {
        libelle: 'EcoRH', submenus: [
            {
                id: 138, libelle: 'EcoRH', route: '/recylog/fonctionAdmin/Ecorh/DBGestionDateCloturePaie', code: 'clefDroitAdmin5', droit: '0x00000200', libelleObjetEntite: 'Cloture Paie'
            },
            {
                id: 139, libelle: 'EcoRH', route: '/recylog/fonctionAdmin/Ecorh/DBAnnulerComptaPaieIndispoPeriode', code: 'clefDroitAdmin5', droit: '0x00000400', libelleObjetEntite: 'Annuler le passage en paie des indisponibilités d\'une période'
            },
            {
                id: 140, libelle: 'EcoRH', route: '/recylog/fonctionAdmin/Ecorh/DBAnnulerComptaPaieIndispoChauffeur', code: 'clefDroitAdmin5', droit: '0x00000800', libelleObjetEntite: 'Annuler le passage en paie des indisponibilités d\'un personnel'
            },
            {
                id: 141, libelle: 'EcoRH', route: '/recylog/fonctionAdmin/Ecorh/DBMasquerIndisponibiliteRaison', code: 'clefDroitAdmin5', droit: '0x00001000', libelleObjetEntite: 'Masquer / Démasquer les motifs d\'indisponibilité'
            },
            {
                id: 155, libelle: 'EcoRH', route: '/recylog/fonctionAdmin/Ecorh/DBAnnulerPassagePaieHeureChauffeur', code: 'clefDroitAdmin5', droit: '0x04000000', libelleObjetEntite: 'Annuler le passage en paie des heures d\'un personnel'
            }
        ]
    },
    {
        libelle: 'Ecotri', submenus: [
            {
                id: 142, libelle: 'Ecotri', route: '/recylog/fonctionAdmin/Ecotri/DBAnnulerTrieBon', code: 'clefDroitAdmin5', droit: '0x00002000', libelleObjetEntite: 'Remonter un bon dans Ecotri'
            }
        ]
    },
    {
        libelle: 'Ecorec Externe', submenus: [
            {
                id: 143, libelle: 'Ecorec Externe', route: '/recylog/fonctionAdmin/Ecorecexterne/DBMAJAssoClientEcorecExterne', code: 'clefDroitAdmin5', droit: '0x00004000', libelleObjetEntite: 'Modification de l\'association d\'un client'
            }
        ]
    },
    {
        libelle: 'ECOBM', submenus: [
            {
                id: 144, libelle: 'ECOBM', route: '/recylog/fonctionAdmin/ECOBM/DBMAJFicheArticle', code: 'clefDroitAdmin5', droit: '0x00008000', libelleObjetEntite: 'Modifier une fiche article'
            }
        ]
    },
    {
        libelle: 'Ecostock', submenus: [
            {
                id: 145, libelle: 'Ecostock', route: '/recylog/fonctionAdmin/Ecostock/DBAnnulerDateFixee', code: 'clefDroitAdmin5', droit: '0x00010000', libelleObjetEntite: 'Annuler une date fixèe'
            },
            {
                id: 146, libelle: 'Ecostock', route: '/recylog/fonctionAdmin/Ecostock/DBSupprimerTriEcostock', code: 'clefDroitAdmin5', droit: '0x00020000', libelleObjetEntite: 'Supprimer un tri'
            }
        ]
    },
    {
        libelle: 'RGPD', submenus: [
            {
                id: 147, libelle: 'RGPD', route: '/recylog/fonctionAdmin/RGPD/DBAnonymiserClient', code: 'clefDroitAdmin5', droit: '0x00040000', libelleObjetEntite: 'Anonymiser un client'
            },
            {
                id: 148, libelle: 'RGPD', route: '/recylog/fonctionAdmin/RGPD/DBAnonymiserDetenteur', code: 'clefDroitAdmin5', droit: '0x00080000', libelleObjetEntite: 'Anonymiser un détenteur (chantier)'
            },
            {
                id: 149, libelle: 'RGPD', route: '/recylog/fonctionAdmin/RGPD/DBAnonymiserMembre', code: 'clefDroitAdmin5', droit: '0x00100000', libelleObjetEntite: 'Anonymiser un membre du personnel'
            }
        ]
    },
    {
        libelle: 'Ecobadge', submenus: [
            {
                id: 156, libelle: 'Ecobadge', route: '/recylog/fonctionAdmin/Ecobadge/DBImportTourneeSyctom', code: 'clefDroitAdmin5', droit: '0x08000000', libelleObjetEntite: 'Importation des tournées'
            },
            {
                id: 157, libelle: 'Ecobadge', route: '/recylog/fonctionAdmin/Ecobadge/AssociationSyctom', code: 'clefDroitAdmin5', droit: '0x10000000', libelleObjetEntite: 'Association des badges Syctom'
            },
            {
                id: 158, libelle: 'Ecobadge', route: '/recylog/fonctionAdmin/Ecobadge/CRSyctom', code: 'clefDroitAdmin5', droit: '0x20000000', libelleObjetEntite: 'Compte Rendu Syctom'
            },
            {
                id: 159, libelle: 'Ecobadge', route: '/recylog/fonctionAdmin/Ecobadge/CREcobadge', code: 'clefDroitAdmin5', droit: '0x40000000', libelleObjetEntite: 'Compte rendu badgeuse'
            },
            {
                id: 172, libelle: 'Ecobadge', route: '/recylog/fonctionAdmin/Ecobadge/paramEcobadge', code: 'clefDroitAdmin6', droit: '0x00010000', libelleObjetEntite: 'Paramétrage Potelet'
            },
            {
                id: 172, libelle: 'Ecobadge', route: '/recylog/fonctionAdmin/Ecobadge/message', code: 'clefDroitAdmin6', droit: '0x00010000', libelleObjetEntite: 'Messages Potelet', nepasAfficherDansParamUser: true
            },
        ]
    },
    {
        libelle: 'Holding', submenus: [
            {
                id: 1, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/clientdoublon', code: 'clefDroitAdmin6', droit: '0x00000008', libelleObjetEntite: 'Supprimer un Client en doublon',
                isHolding: true
            },
            {
                id: 2, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/chantierdoublon', code: 'clefDroitAdmin6', droit: '0x00000010', libelleObjetEntite: 'Supprimer un Chantier en doublon',
                isHolding: true
            },
            {
                id: 3, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/personneldoublon', code: 'clefDroitAdmin6', droit: '0x00000020', libelleObjetEntite: 'Supprimer un personnel en doublon',
                isHolding: true
            },
            {
                id: 4, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/bloquerclient', code: 'clefDroitAdmin6', droit: '0x00000040', libelleObjetEntite: 'Bloquer un Client',
                isHolding: true
            },
            {
                id: 5, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/debloquerclient', code: 'clefDroitAdmin6', droit: '0x00000080', libelleObjetEntite: 'Débloquer un Client',
                isHolding: true
            },
            {
                id: 6, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/codeclient', code: 'clefDroitAdmin6', droit: '0x00000100', libelleObjetEntite: 'Modifier le code d\'un Client',
                isHolding: true
            },
            {
                id: 9, libelle: 'Ecorec', route: '/recylog/fonctionAdmin/ecorec/visibiliteClient', code: 'clefDroitAdmin6', droit: '0x00000200', libelleObjetEntite: 'Visibilité d\'un client',
                isHolding: true
            }
        ]
    },
]